// Clevertap stuff
import { resolveKeysInObjectsArrays, isUserSignedIn, getCookie, isEmpty, pageLoadTime, getURLSearchParam } from 'utils/browserHelper'
import ClevertapReact from './clevertap'

const CLEVERTAP_KEY = (process.env.CDN_ENV === 'qa' ? process.env.CT_PUBLIC_CLEVERTAP_TEST_KEY :  process.env.CT_PUBLIC_CLEVERTAP_KEY ) || null

class Clevertap {
    constructor() {
        this.enabled = false
        if (CLEVERTAP_KEY) {
            this.enabled = true
            ClevertapReact.initialize(CLEVERTAP_KEY)
        }
    }

    event = (name, payload = {}) => {
        try {
            if (this.enabled) {
                const ctAb = isEmpty(getCookie('ct-ab')) ? {} : JSON.parse(decodeURIComponent(getCookie('ct-ab')))

                const domain = resolveKeysInObjectsArrays(['location', 'hostname'], window);
                const utmSource = getURLSearchParam("utm_source");

                payload.platform = 'Desktop'
                payload.domainName = domain || 'NA'
                payload.is_logged_in = isUserSignedIn() ? 'yes' : 'no'
                payload.hotels_srp_abcookie = ctAb['h_searchorder'] || 'N/A'
                payload.testGlobal_abcookie = ctAb['testGlobal'] || 'N/A'
                payload.h_exp13_abcookie = ctAb['h_exp13'] || 'N/A'
                payload.h_exp16_abcookie = ctAb['h_exp16'] || 'N/A'
                payload.h_exp17_abcookie = ctAb['h_exp17'] || 'N/A'
                payload.RNIFlowType_abcookie = ctAb['RNIFlowType'] || 'N/A'
                payload.login_banner_cookie = ctAb['login_init'] || 'N/A'
                payload.h_exp_dom_abcookie = ctAb['h_exp_dom'] || 'N/A'
                payload.h_exp_intl_abcookie = ctAb['h_exp_intl'] || 'N/A'
                payload.pageLoadTime = pageLoadTime()
                payload.utm_source = utmSource || 'N/A'
                setTimeout(() => {
                    ClevertapReact.event(name, payload)
                }, 300)
            }
        } catch (e) {
            console.error(e)
        }
    }

    profile = payload => {
        if (this.enabled) {
            ClevertapReact.profile(payload)
        }
    }

    logout = () => {
        if (this.enabled) {
            ClevertapReact.logout()
        }
    }
}

const ClevertapObject = new Clevertap()
export default ClevertapObject
